import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchGrouptripsCity_list = async () => {
  try {
    const response = await fetch(`${API_URL}/grouptripsCity_list`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("GrouptripsCity_list API Error:", error);
    return null;
  }
};
